import moment from "moment";

export const formatMoment = (moment) => moment.format("HH:mm DD.MM.YYYY");
export const getFormatedDateFromTimestamp = (timestamp) =>
	formatMoment(moment.unix(timestamp));
